module.exports = __webpack_public_path__ + "img/upload.30f67776.svg";